import tokeys from 'tokeys';

export const TransferPageType = tokeys(['masterAccount', 'topupLoad']);

export const TRANSFER_PAGE_SEARCH_NAME = 'tab';
export const TRANSFER_PAGE_QUERY_NAME = '?tab=';
